import request from './request';

// 获取知识列表
export function getKnowledgeList(params) {
  return request({
    url: '/knowledge',
    method: 'get',
    params
  });
}

// 获取当前用户可见的知识类型列表（角色感知：editor 不含受保护类型）
export function getVisibleKnowledgeTypes() {
  return request({
    url: '/knowledge/types',
    method: 'get'
  });
}

// 获取知识详情
export function getKnowledgeById(id, versionStrategy = 'latest') {
  return request({
    url: `/knowledge/${id}`,
    method: 'get',
    params: { version: versionStrategy }
  });
}

// 创建知识
export function createKnowledge(data) {
  return request({
    url: '/knowledge',
    method: 'post',
    data
  });
}

// 更新知识
export function updateKnowledge(id, data) {
  return request({
    url: `/knowledge/${id}`,
    method: 'put',
    data
  });
}

// 删除知识
export function deleteKnowledge(id) {
  return request({
    url: `/knowledge/${id}`,
    method: 'delete'
  });
}

// 搜索知识
export function searchKnowledge(data) {
  return request({
    url: '/knowledge/search',
    method: 'post',
    data
  });
}

// ============================================
// 知识版本管理 API
// ============================================

// 获取知识版本历史列表
export function getKnowledgeVersionHistory(knowledgeId) {
  return request({
    url: `/knowledge/${knowledgeId}/versions`,
    method: 'get'
  });
}

// 获取知识指定版本详情
export function getKnowledgeVersionDetail(knowledgeId, version) {
  return request({
    url: `/knowledge/${knowledgeId}/versions/${version}`,
    method: 'get'
  });
}

// 对比两个版本
export function compareKnowledgeVersions(knowledgeId, v1, v2) {
  return request({
    url: `/knowledge/${knowledgeId}/versions-diff`,
    method: 'get',
    params: { v1, v2 }
  });
}

// 发布指定版本
export function publishKnowledgeVersion(knowledgeId, version) {
  return request({
    url: `/knowledge/${knowledgeId}/versions/${version}/publish`,
    method: 'post'
  });
}

// 获取知识内容（根据版本策略）
export function getKnowledgeContent(knowledgeId, strategy = 'published') {
  return request({
    url: `/knowledge/${knowledgeId}/content`,
    method: 'get',
    params: { strategy }
  });
}

// 批量查询知识详情
export function batchGetKnowledge(knowledgeIds) {
  return request({
    url: '/knowledge/batch',
    method: 'post',
    data: { knowledge_ids: knowledgeIds }
  });
}

// ============================================
// 回收站 API
// ============================================

// 获取回收站列表
export function getRecycleBinList(params) {
  return request({
    url: '/knowledge/recycle-bin/list',
    method: 'get',
    params
  });
}

// 恢复已删除的知识
export function restoreKnowledge(id) {
  return request({
    url: `/knowledge/recycle-bin/${id}/restore`,
    method: 'post'
  });
}

